export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">随时随地 · 流畅观影</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                  宅男视频已全面适配移动端，无需下载安装APP。打开手机浏览器直接访问，
                  久久视频、小蓝视频、豆花视频全平台内容尽在掌中，高清流畅播放随开随看。
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                  <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-200/70">
                    <i className="ri-smartphone-line text-primary-500"></i>
                    <span className="text-sm text-foreground-700">手机浏览器直达</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-200/70">
                    <i className="ri-tablet-line text-accent-500"></i>
                    <span className="text-sm text-foreground-700">平板适配完美</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-200/70">
                    <i className="ri-wifi-line text-secondary-500"></i>
                    <span className="text-sm text-foreground-700">免下载零内存</span>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-6xl text-primary-500"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}